import React, { useCallback, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import axios from 'axios';
import { Input } from '@thd-olt-component-react/input';
import { Loader } from '@thd-olt-component-react/loader';
import { Button } from '@thd-olt-component-react/button';
import helper from '../../helper';

const ShareBeltEmail = (props) => {

  const experienceContext = useContext(ExperienceContext);

  const {
    store
  } = experienceContext;

  const [message, setMessage] = useState({});
  const [uiState, setUIState] = useState({
    active: false,
    bttn: false,
    message: '',
    toggleClass: ''
  });

  const {
    itemId
  } = props;

  const onClickSubmitHandler = useCallback(async (evt) => {

    const storeId = store.storeId;

    evt.preventDefault();
    let postData = {
      fromAddress: message.senderEmailText,
      sku: itemId,
      storeId,
      toAddress: message.recepientEmailText,
    };
    try {

      setUIState({
        ...uiState,
        active: true,
        bttn: true
      });

      const response = await axios.post('/p/svcs/sendProductEmail', postData);

      setUIState({
        active: false,
        bttn: false,
        message: `Great! You’ve shared this item with ${message.recepientEmailText}`,
        toggleClass: 'success'
      });

    } catch (error) {
      setUIState({
        active: false,
        bttn: false,
        message: 'We’re sorry, an unexpected error prevented your item from being shared. Please try again.',
        toggleClass: 'error'
      });
    }
  }, [message]);

  return (
    <div className="thd-sharebelt-email-template">
      <p className="thd-sharebelt-email-template__heading">
        Pass it along to someone you know! We&apos;ll
        send them a quick note with the product details.
      </p>
      <form className="thd-sharebelt-email-template__form">
        <div className="thd-sharebelt-email-template__form-input">
          <span className="form-input">
            <Input
              errorText="Please provide your email address, formatted as you@example.com"
              type="text"
              header="To"
              placeholder="yourfriend@domain.com"
              value={message.recepientEmailText}
              validation={(text) => {
                setMessage({
                  ...message,
                  recepient: helper.validateEmail(text),
                  recepientEmailText: text
                });
                return (helper.validateEmail(text));
              }}
            />
          </span>
          <span className="form-input">
            <Input
              errorText="Please provide your email address, formatted as you@example.com"
              header="From"
              value={message.senderEmailText}
              placeholder="youremail@domain.com"
              validation={(text) => {
                setMessage({
                  ...message,
                  sender: helper.validateEmail(text),
                  senderEmailText: text
                });
                return (helper.validateEmail(text));
              }}
            />
          </span>
        </div>
        <div className="thd-sharebelt-email-template__button-container">
          <div className={`thd-sharebelt-email-template__message ${uiState.toggleClass}`}>
            {uiState.message}
          </div>
          <Button
            onClick={onClickSubmitHandler}
            className={((!message.recepient) || (!message.sender)) ? 'disabled' : 'bttn'}
          >
            <Loader active={uiState.active} bttn={uiState.bttn} />
            <span className="bttn--text">Send Email</span>
          </Button>
        </div>
      </form>
    </div>
  );
};

ShareBeltEmail.displayName = 'ShareBeltEmail';

ShareBeltEmail.propTypes = {
  itemId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])
};

ShareBeltEmail.defaultProps = {
  itemId: null
};

export default ShareBeltEmail;
